import React from "react";
import ReactDOM from "react-dom/client";
import App from "./AppURL"; // URL token-based license gate
import { initWidget } from "./config/widgetConfig.js";

initWidget(async (widget) => {
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <App widget={widget}/>
    </React.StrictMode>
  );
  widget.addEvent("onLoad", () => root);
});
